import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { I18nProvider } from '@/i18n'
import { ThemeProvider } from '@/components/patterns/ThemeProvider'
import { ToastProvider } from '@/components/ui/Toast'
import { ErrorBoundary } from '@/components/system/ErrorBoundary'
import { ScrollToTop } from '@/components/system/ScrollToTop'
import { RouteAnnouncer } from '@/components/system/RouteAnnouncer'
import { SiteLayout } from '@/components/layout/SiteLayout'
import { routes } from '@/config/pages-registry'
import NotFound from '@/pages/NotFound'

/**
 * App — [FRAME] a data-driven router.
 *
 * TO ADD A PAGE: create a file in `src/pages/` and add ONE line to
 * `src/config/pages-registry.ts`. This file never needs editing.
 *
 * Wrapping order: language → light/dark → notifications → error trap → router.
 */
function App() {
  return (
    <I18nProvider>
      <ThemeProvider defaultMode="system">
        <ToastProvider>
          <ErrorBoundary>
            <BrowserRouter>
              <ScrollToTop />
              <RouteAnnouncer />
              <SiteLayout>
                <Routes>
                  {routes.map(({ path, component: Page }) => (
                    <Route key={path} path={path} element={<Page />} />
                  ))}
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </SiteLayout>
            </BrowserRouter>
          </ErrorBoundary>
        </ToastProvider>
      </ThemeProvider>
    </I18nProvider>
  )
}

export default App
